// F13a (FR-O10a): operator top-N orgs by storage, 30-day public egress and transcode time.
// GET /ops/usage/top?metric=storage|egress|transcode. DS components and tokens only (SD35).
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Card, SegmentedControl } from "@grackle/ui";
import { api, ApiFail } from "../api/client";
import { formatBytes } from "../library/format";
import { Notice } from "../components/ui";

type Metric = "storage" | "egress" | "transcode";
interface TopOut {
  metric: Metric;
  items: { org_id: string; name: string; value: number }[];
}

export function formatMetric(metric: Metric, value: number): string {
  return metric === "transcode" ? `${Math.round(value / 60)} min` : formatBytes(value);
}

const OPTIONS = [
  { value: "storage", label: "Storage" },
  { value: "egress", label: "Public bandwidth, 30 days" },
  { value: "transcode", label: "Transcode time, 30 days" },
];

export default function OpsTopUsage() {
  const [metric, setMetric] = useState<Metric>("storage");
  const [data, setData] = useState<TopOut | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    setData(null);
    setError(null);
    api<TopOut>("GET", `/ops/usage/top?metric=${metric}&limit=10`)
      .then(setData)
      .catch((err) => setError(err instanceof ApiFail ? err.message : "Couldn't load usage."));
  }, [metric]);

  return (
    <Card
      size="sm"
      title="Top orgs by usage"
      className="ops-top-usage"
      aria-label="Top orgs by usage"
      action={<SegmentedControl options={OPTIONS} value={metric} onChange={(v) => setMetric(v as Metric)} />}
    >
      {error ? <Notice tone="error">{error}</Notice> : null}
      {data && data.items.length === 0 ? <span className="gk-sm">Nothing recorded yet.</span> : null}
      {data && data.items.length > 0 ? (
        <Card size="flush" className="admin-table-card">
<table className="admin-table">
          <tbody>
            {data.items.map((row) => (
              <tr key={row.org_id}>
                <td>
                  <Link to={`/ops/orgs/${row.org_id}`}>{row.name}</Link>
                </td>
                <td className="num mono">{formatMetric(metric, row.value)}</td>
              </tr>
            ))}
          </tbody>
        </table>
</Card>
      ) : null}
    </Card>
  );
}
